import Booth from './Booth';

export default Booth;
